// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__IdWJ1","logoContainer":"Header_logoContainer__1KHH2","btnsContainer":"Header_btnsContainer__2eZOU","signinbtn":"Header_signinbtn__2LKMH"};